// Notifications
export const GET_NOTIFICATIONS_PENDING = 'GET_NOTIFICATIONS_PENDING';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_REJECTED = 'GET_NOTIFICATIONS_REJECTED';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
// Auth
export const AUTH_USER_SET = 'AUTH_USER_SET';
// Rel types
// GET relationship types 
export const GET_RELATIONSHIP_TYPES_PENDING = 'GET_RELATIONSHIP_TYPES_PENDING';
export const GET_RELATIONSHIP_TYPES_SUCCESS = 'GET_RELATIONSHIP_TYPES_SUCCESS';
export const GET_RELATIONSHIP_TYPES_REJECTED = 'GET_RELATIONSHIP_TYPES_REJECTED';
// Orgs
// GET orgs
export const GET_ORGANIZATIONS_PENDING = 'GET_ORGANIZATIONS_PENDING';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_REJECTED = 'GET_ORGANIZATIONS_REJECTED';
// PUT orgs
export const UPDATE_ORGANIZATION_PENDING = 'UPDATE_ORGANIZATION_PENDING';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_REJECTED = 'UPDATE_ORGANIZATION_REJECTED';
// POST orgs
export const CREATE_ORGANIZATION_PENDING = 'CREATE_ORGANIZATION_PENDING';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_REJECTED = 'CREATE_ORGANIZATION_REJECTED';
export const UPDATE_ORGANIZATION_NAME_PENDING = 'UPDATE_ORGANIZATION_NAME_PENDING';
export const UPDATE_ORGANIZATION_NAME_SUCCESS = 'UPDATE_ORGANIZATION_NAME_SUCCESS';
export const UPDATE_ORGANIZATION_NAME_REJECTED = 'UPDATE_ORGANIZATION_NAME_REJECTED';
// DEL orgs
export const DELETE_ORGANIZATION_PENDING = 'DELETE_ORGANIZATION_PENDING';
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_REJECTED = 'DELETE_ORGANIZATION_REJECTED';
// Lots
// GET LOTS
export const GET_LOTS_PENDING = 'GET_LOTS_PENDING';
export const GET_LOTS_SUCCESS = 'GET_LOTS_SUCCESS';
export const GET_LOTS_REJECTED = 'GET_LOTS_REJECTED';
// PUT LOTS
export const UPDATE_LOT_PENDING = 'UPDATE_LOT_PENDING';
export const UPDATE_LOT_SUCCESS = 'UPDATE_LOT_SUCCESS';
export const UPDATE_LOT_REJECTED = 'UPDATE_LOT_REJECTED';
// Team
// GET team
export const GET_TEAM_PENDING = 'GET_TEAM_PENDING';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_REJECTED = 'GET_TEAM_REJECTED';
// POST team
export const CREATE_USER_PENDING = 'CREATE_USER_PENDING';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_REJECTED = 'CREATE_USER_REJECTED';
// PUT team
export const UPDATE_USER_PENDING = 'UPDATE_USER_PENDING';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_REJECTED = 'UPDATE_USER_REJECTED';
// DEL team
export const DELETE_USER_PENDING = 'DELETE_USER_PENDING';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_REJECTED = 'DELETE_USER_REJECTED';
// Wizard
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const UPDATE_EDIT_DATA = 'UPDATE_EDIT_DATA';
// Modal
export const SET_DIALOG_VISIBILITY = 'SET_DIALOG_VISIBILITY';
export const SET_ERROR_DIALOG = 'SET_ERROR_DIALOG';
// Toasts
export const ADD_TOAST = 'ADD_TOAST';
export const DISMISS_TOAST = 'DISMISS_TOAST';
// Filters
export const SET_ORG_FILTERED_DATA = 'SET_ORG_FILTERED_DATA';
export const SET_PEOPLE_FILTERED_DATA = 'SET_PEOPLE_FILTERED_DATA';
export const SET_LOTS_FILTERED_DATA = 'SET_LOTS_FILTERED_DATA';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const CLEAR_SEARCH_TERM = 'CLEAR_SEARCH_TERM';
// Registration email
export const REGISTRATION_EMAIL_PENDING = 'REGISTRATION_EMAIL_PENDING';
export const REGISTRATION_EMAIL_SUCCESS = 'REGISTRATION_EMAIL_SUCCESS';
export const REGISTRATION_EMAIL_REJECTED = 'REGISTRATION_EMAIL_REJECTED';
// Recursive Tree
export const SET_RECURSIVE_EDIT_DATA = 'SET_RECURSIVE_EDIT_DATA';
export const SET_RECURSIVE_EDIT_DATA_STARTED = 'SET_RECURSIVE_EDIT_DATA_STARTED';
export const SET_RECURSIVE_EDIT_DATA_PENDING = 'SET_RECURSIVE_EDIT_DATA_PENDING';
export const SET_RECURSIVE_EDIT_DATA_FULFILLED = 'SET_RECURSIVE_EDIT_DATA_FULFILLED';
export const SET_RECURSIVE_EDIT_DATA_REJECTED = 'SET_RECURSIVE_EDIT_DATA_REJECTED';
export const CREATED_TREE = 'CREATED_TREE';
export const CREATED_TREE_FULFILLED = 'CREATED_TREE_FULFILLED';
export const FAILED_TREE_CREATION = 'FAILED_TREE_CREATION';
// Relationships
export const UPDATE_RELATIONSHIPS_PENDING = 'UPDATE_RELATIONSHIPS_PENDING';
export const UPDATE_RELATIONSHIPS_SUCCESS = 'UPDATE_RELATIONSHIPS_SUCCESS';
export const UPDATE_RELATIONSHIPS_REJECTED = 'UPDATE_RELATIONSHIPS_REJECTED';
// Registration Tree, Organizaton Tree
export const SET_ORG_TREE = 'SET_ORG_TREE';
export const SET_ORG_TREE_FULFILLED = 'SET_ORG_TREE_FULFILLED';
// VenueTeam/Landmarks
export const GET_LANDMARKS_PENDING = 'GET_LANDMARKS_PENDING';
export const GET_LANDMARKS_SUCCESS = 'GET_LANDMARKS_SUCCESS';
export const GET_LANDMARKS_REJECTED = 'GET_LANDMARKS_REJECTED';



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js